import React from 'react';
import { X } from 'lucide-react';
import CandidateHistory from '@/components/candidates/CandidateHistory';

const HistoryDialog = ({ isOpen, onClose, candidate, selectedVacancy }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" onClick={onClose}>
      <div className="bg-card p-6 rounded-lg shadow-lg relative w-[700px] max-w-full" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition duration-200">
          <X size={24} />
        </button>
        {/* <p className="mb-2"><strong>Name:</strong> {candidate.name} <strong>Email:</strong> {candidate.email}</p> */}
        <div className="mt-6">
          <strong className="text-lg  font-semibold">Applied Jobs</strong> 
          <CandidateHistory candidate={candidate} />
        </div>
        <div className="flex justify-end mt-4">
          <button onClick={onClose} className="bg-muted text-foreground px-4 py-2 rounded">Close</button>
        </div>
      </div>
    </div>
  );
};

export default HistoryDialog; 